// @ts-nocheck
class WIgridview extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // this.initGrid();
        this.clickGrid();
    }

    disconnectedCallback() {

    }

    // Initialize grid based on default selected view
    initGrid() {
        const proGrid = document.querySelector('.WI_mainCollection_main #WI_mainCollection_grpGrid');
        const width = window.innerWidth;
        // Mobile (<768px): default view 2, iPad (768-1024px): default view 4, Desktop (>1024px): default view 4
        const defaultView = width < 768 ? '2' : '4';
        if (proGrid) {
            proGrid.classList.add(`grid-view-${defaultView}`);
        }
    }

    // click on view number button
    clickGrid() {
        this.addEventListener('click',(e)=>{
            if (e.target?.tagName.toLowerCase() === 'button') {
                 document.querySelectorAll('.GridViewBtn').forEach(btn => {
                    btn.style.textDecoration = 'none';
                });
                e.target.style.textDecoration = "underline";
                let targetData = e.target.getAttribute('data-num');
                let proGrid = document.querySelector('.WI_mainCollection_main #WI_mainCollection_grpGrid');
                proGrid.classList.remove('grid-view-1', 'grid-view-2', 'grid-view-4', 'grid-view-8');
                proGrid.classList.add(`grid-view-${targetData}`);
                let mainCollectionProduct = document.querySelector('.WI_mainCollection_product');
                if (targetData == 1){
                    mainCollectionProduct.classList.add('WI_mainCollection_product_noPadding');
                    mainCollectionProduct.classList.add('WI_productCard_in_info_addPadding');
                }else{
                    mainCollectionProduct.classList.remove('WI_mainCollection_product_noPadding');
                    mainCollectionProduct.classList.remove('WI_productCard_in_info_addPadding');
                }
                if (targetData == 8) {
                    document.dispatchEvent(new CustomEvent("eight:grid", {bubbles: true}));
                }
                else if (targetData == 4) {
                    document.dispatchEvent(new CustomEvent("four:grid", {bubbles: true}));
                }else{
                    document.dispatchEvent(new CustomEvent("noeight:grid", {bubbles: true}));
                }
            }
        });
    }
}

customElements.define('wi-gridview', WIgridview);